import { UIIcon } from '../../../config/icons';
import { FPageBlock, FPageFAQGroup, FPageFAQItem, FPageTestimonialItem } from '../../mdl/f-page-block';
import { uiSetBG } from '../../ui/bg';
import { UIInputAdapter, UIViewAdapter } from '../../ui/component/adapter';
import { UIList } from '../../ui/component/list';
import { UICheckbox } from '../../ui/component/toggle';
import { $el } from '../../ui/elements';
import { $on } from '../../y/events';
import { $form } from '../../y/form';
import { EDBlockSpec, EDBlock } from '../block';
import { EDBlockContainer, EDButtonSpec } from '../editor';
import { EDI18NInput } from '../input';

export const ed_page_faq_block: EDBlockSpec<FPageBlock> = {
    key: 'faq',
    editor_block: class extends EDBlock {
        _groups: UIInputAdapter<FPageFAQGroup>;

        constructor(container: EDBlockContainer) {
            const headers = new UICheckbox({ title: 'Section headers' });
            const expanded = new UICheckbox({ title: 'Always expanded' });

            const properties = $el.DIV('l-form', [headers, expanded]);

            const groups = new UIInputAdapter<FPageFAQGroup>(() => {
                const title = new EDI18NInput({ multiline: true, styleable: true, classes: 'r-title', placeholder: 'Title' });
                const items = new UIInputAdapter<FPageFAQItem>(() => {
                    const q = new EDI18NInput({ styleable: true, placeholder: 'Question', classes: 'r-text' });
                    const a = new EDI18NInput({ multiline: true, styleable: true, classes: 'r-box', placeholder: 'Answer', default_format: 'text' });

                    const arrow = $el.DIV('r-arrow');
                    arrow.innerHTML = '<svg class="r-left" viewBox="0 0 96 96"><rect width="26" height="7" x="25.5" y="44.5"/></svg>' +
                        '<svg class="r-right" viewBox="0 0 96 96"><rect width="26" height="7" x="44.5" y="44.5"/></svg>';

                    return {
                        view: $el.DIV('o-faq-item', [$el.DIV('r-q', [q, arrow]), $el.DIV('r-a', a)]),
                        input: $form({ q, a })
                    };
                });

                return {
                    view: new UIList([new UIViewAdapter(title), items], { classes: ['o-faq-group', !headers.value && 'm-no-header'] }),
                    input: $form({ title, items }),
                    extra: items,
                };
            })

            const list = new UIList(groups, { classes: 'w-block-1200 b b-content' })
            super($form({ groups, headers, expanded }), container, 'FAQ', properties, list.ui_elem);

            this._groups = groups;

            $on(headers, 'value', v => {
                for(const g of groups.views) {
                    g.classList.toggle('m-no-header', !v);
                }
            })
        }

        override getButtons(): EDButtonSpec[] {
            const rect = this.ui_elem.getBoundingClientRect();

            const buttons: EDButtonSpec[] = [{
                icon: UIIcon.PLUS,
                classes: 'm-square',
                action: () => {
                    this._groups.push({ title: {}, items: [{ q: {}, a: {} }] });
                },
                position: [rect.right - 15, rect.bottom - 15],
                tooltip: 'Add group'
            }, ...this.parent.getChildButtons(this)];

            for(const e of this._groups.entries) {
                const view = e.view;
                const input = e.input;
                if(!view || !input) continue;

                const item_rect = view.ui_elem.getBoundingClientRect();
                buttons.push({
                    icon: UIIcon.PLUS,
                    classes: 'm-round',
                    action: () => {
                        e.extra.push({ q: {}, a: {} });
                    },
                    position: [item_rect.left - 36, item_rect.bottom - 30],
                    tooltip: 'Add item'
                });
            }

            return buttons;
        }
    },
};

export const ed_page_map_block: EDBlockSpec<FPageBlock> = {
    key: 'map',
    editor_block: class extends EDBlock {
        constructor(container: EDBlockContainer) {
            super($form({}), container, 'Map');

            const fake_map = $el.DIV('ui-map');
            uiSetBG(fake_map, { size: 'cover', cdn: 'images/assets/editor-map.png' });

            this.classList.add('blk-map', 'b', 'b-block');
            this.ui_add(fake_map);
        }
    },
};

export const ed_page_testimonial_block: EDBlockSpec<FPageBlock> = {
    key: 'testimonial',
    editor_block: class extends EDBlock {
        _items: UIInputAdapter<FPageTestimonialItem>;

        constructor(container: EDBlockContainer) {
            const pink = new UICheckbox({ title: 'Pink background' });

            const properties = $el.DIV('l-form', [pink]);

            const items = new UIInputAdapter<FPageTestimonialItem>(() => {
                const header = new EDI18NInput({ multiline: true, styleable: false, classes: 'r-text', placeholder: 'Text' });
                const text = new EDI18NInput({ multiline: true, styleable: false, classes: 'r-signature', placeholder: 'Subtext' });
                return {
                    view: $el.DIV('o-bubble', [header, text]),
                    input: $form({ header, text })
                }
            })

            const list = new UIList(items, { classes: 'blk-testimonial b b-content m-editor' });
            super($form({ items, pink }), container, 'Testimonials', properties, list.ui_elem);

            this._items = items;

            // $on(pink, 'value', v => {
            //     listd.classList.toggle('m-pink', !!v);
            // });
        }

        override getButtons(): EDButtonSpec[] {
            const rect = this.ui_elem.getBoundingClientRect();

            return [{
                icon: UIIcon.PLUS,
                classes: 'm-square',
                action: () => {
                    this._items.push({ header: {}, text: {} });
                },
                position: [rect.right - 15, rect.bottom - 15],
                tooltip: 'Add item'
            }, ...this.parent.getChildButtons(this)];
        }
    }
};
